import type { Command } from '@o2d/history';
import type { BoardState } from '../state/board-state.js';

export interface ResizeSnapshot {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
}

/**
 * Resize (and optionally rotate/reposition) a single object to exactly
 * the given end state. Captured before/after snapshots make undo trivial.
 */
export class ResizeObjectCommand implements Command<BoardState> {
  readonly label = 'Objekt skalieren';

  constructor(
    private readonly _id: string,
    private readonly _from: ResizeSnapshot,
    private readonly _to: ResizeSnapshot,
  ) {}

  get objectId(): string {
    return this._id;
  }

  get from(): ResizeSnapshot {
    return this._from;
  }

  get to(): ResizeSnapshot {
    return this._to;
  }

  apply(state: BoardState): void {
    this.write(state, this._to);
  }

  revert(state: BoardState): void {
    this.write(state, this._from);
  }

  private write(state: BoardState, snap: ResizeSnapshot): void {
    const obj = state.getObject(this._id);
    if (!obj) return;
    state.updateObject({
      ...obj,
      x: snap.x, y: snap.y,
      width: snap.width, height: snap.height,
      rotation: snap.rotation,
    });
  }
}
